export const hospitalInformationProps = [
  {
    title: "Find coverage fast",
    description:
      "Take your pick of licensed vets & techs. Stay productive while your staff takes time off!",
  },
  {
    title: "Staffing made easy",
    description: "Roo handles payroll, taxes, screening & more, taking work off your plate.",
  },
  {
    title: "Free to join & risk free",
    description: "Only pay for confirmed shifts. If you don't find coverage, you don't pay.",
  },
];

const contractorValueProps = [
  {
    title: "Flexible schedule",
    description: "Work when you want, where you want, as much or as little as you like!",
  },
  {
    title: "Get paid fast",
    description: "Hassle-free payments via direct deposit in as little as two business days!",
  },
];

export const vetInformationProps = [
  {
    title: "Earn more with relief",
    description: "Make nearly twice as much per hour as the average full-time veterinarian!",
  },
  ...contractorValueProps,
];

export const techInformationProps = [
  {
    title: "Boost your income",
    description: "Make more per hour than the average vet tech with more opportunities to earn!",
  },
  ...contractorValueProps,
];

export const studentInformationProps = [
  {
    title: "Learn from dedicated mentors",
    description:
      "Build relationships with DVMs and veterinary professionals that will last your entire career!",
  },
  {
    title: "Put your skills into action",
    description:
      "Gain confidence in your clinical ability, build your resume, and kickstart your career!",
  },
  {
    title: "Travel and explore",
    description:
      "Practice all over the country and try new specialties while every option is available!",
  },
];

export const HOSPITAL_REGISTRATION_LOCALSTORAGE_KEY = "hospital-registration-form";
